// Autocompletado del alta de cliente con el padrón DNIT —
// SPEC_ALTA_CLIENTE_DNIT_Y_RECEPTOR_v0.1.md RN-DN2 a RN-DN4 (en pos-graciela-api/docs).
//
// Lo que trae el padrón se PROPONE: llena sólo los campos vacíos y nunca pisa
// lo que el operador ya escribió. El tipo de persona se sugiere salvo que el
// operador ya lo haya elegido a mano.

// RN-DN2: se consulta con al menos 5 dígitos (CI o RUC, con o sin DV).
export const documentoConsultable = (valor) => /^\d{5,}(-\d)?$/.test(String(valor || '').replace(/[.\s]/g, ''))

const vacio = (v) => !String(v ?? '').trim()

/**
 * aplicarPadron — devuelve el form con los datos del padrón en los campos
 * vacíos (SPEC_FORMULARIO_CLIENTE_v0.1.md RN-FC2, RN-FC3).
 * @param form       { nombre_completo, documento: { tipo, numero }, ruc_padron, identificacion: { tipo_persona, nombres, apellidos, razon_social } }
 * @param cliente    el `cliente` que devuelve /api/clients/padron (origen padron)
 * @param tipoTocado el operador ya eligió el tipo de persona a mano
 */
export const aplicarPadron = (form, cliente, { tipoTocado = false } = {}) => {
  const id = { ...(form.identificacion || {}) }
  const documento = { ...(form.documento || {}) }
  const siguiente = { ...form, identificacion: id, documento }
  if (vacio(siguiente.nombre_completo) && cliente.nombre_completo) siguiente.nombre_completo = cliente.nombre_completo
  const numero = String(documento.numero || '').replace(/[.\s]/g, '')
  if (documento.tipo === 'CI' && cliente.ruc && cliente.ruc_sin_dv === numero) {
    // RN-FC2: la cédula de un contribuyente se factura al RUC.
    siguiente.ruc_padron = cliente.ruc
  }
  if (documento.tipo === 'RUC' && cliente.ruc && numero === cliente.ruc_sin_dv) {
    // RN-FC3: se tipeó el RUC sin DV; el padrón lo completa.
    documento.numero = cliente.ruc
  }
  if (vacio(id.nombres) && cliente.nombres) id.nombres = cliente.nombres
  if (vacio(id.apellidos) && cliente.apellidos) id.apellidos = cliente.apellidos
  if (vacio(id.razon_social) && cliente.razon_social) id.razon_social = cliente.razon_social
  if (!tipoTocado && cliente.tipo_persona_sugerido) id.tipo_persona = cliente.tipo_persona_sugerido
  return siguiente
}

/** El aviso que acompaña al autocompletado (RN-DN4). */
export const avisoPadron = (cliente) => {
  if (!cliente) return ''
  const fecha = cliente.padron_actualizado_en ? new Date(cliente.padron_actualizado_en).toLocaleDateString('es-PY') : null
  const base = `Datos del padrón DNIT${fecha ? ` (actualizado al ${fecha})` : ''}. Revisalos antes de guardar.`
  return cliente.ruc_activo === false && cliente.estado_ruc ? `${base} Atención: el RUC figura como «${cliente.estado_ruc}».` : base
}
